<template>
  <div class="main-table-wrapper">
    <el-table
      :data="data">
      <el-table-column
        :label="$tc('general.club')">
        <template slot-scope="scope">
          {{ scope.row.club.shortName }}
        </template>
      </el-table-column>

      <el-table-column
        label="%"
        width="80px">
        <template slot-scope="scope">
          {{ scope.row.deduction }}%
        </template>
      </el-table-column>

      <el-table-column
        :label="$tc('general.actions')"
        width="110px"
        align="right">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" circle @click="$emit('edit', scope.row)" />
          <el-button type="danger" icon="el-icon-delete" circle @click="beforeRemove(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: null
    }
  },

  methods: {
    async beforeRemove (deduction) {
      try {
        await this.$confirm(`${this.$tc('messages.ask_remove_club_deduction')}: ${deduction.club.shortName}`)
        this.$emit('delete', deduction)
      } catch {}
    }
  }
}
</script>
